import { cn } from '@/lib/utils';
import { useTheme } from '../providers';

interface LogoProps {
  className?: string;
}

const Logo = ({ className }: LogoProps) => {
  const { theme } = useTheme();

  return (
    <img
      src={'/images/logos/cogknit-logo-black.png'}
      alt="Logo"
      className={cn('h-5 w-auto duration-300', theme === 'dark' ? 'invert' : '', className)}
    />
  );
};

export default Logo;
